document.addEventListener("DOMContentLoaded", function() {
    $('.overviewAccordion').trigger('click');
    function isEmpty(el) {
      return !$.trim(el.html());
    }
    let all_are_hidden1 = true;
    let all_are_hidden2 = true;
    $('#tblNodes').each(function () {
      if ($(this).css('display') !== 'none') {
        all_are_hidden1 = false;
        return false;
      }
    });
    if (all_are_hidden1 == true) {
      $('.overviewAccordion').css('display', 'none');
    } else {
      $('.overviewAccordion').css('display', 'block');
    }
    $('#tblNodes2').each(function () {
      if ($(this).css('display') !== 'none') {
        all_are_hidden2 = false;
        return false;
      }
    });console.log("Load event");

    if (all_are_hidden2 == true) {
      $('.specificationAccordion').css('display', 'none');
    } else {
      $('.specificationAccordion').css('display', 'block');
    }
    if (isEmpty($('#tblNodes'))) {
      $('.overviewAccordion').css('display', 'none');
    }

    if (isEmpty($('#tblNodes2'))) {
      $('.specificationAccordion').css('display', 'none');
    }
    if (
      (all_are_hidden1 == true && all_are_hidden2 == true) ||
      ($('.specificationAccordion').css('display') == 'none' && $('.overviewAccordion').css('display') == 'none')
    ) {
      $('.container_X').css('display', 'none');
    } else {
      $('.container_X').css('display', 'block');
    }
  });
    // $(document).on("click",".accordion1",function(event){
    //   event.preventDefault();
    //   this.classList.toggle("active_1");
    //   this.classList.toggle("headerBlu");
    //   var panel1 = this.nextElementSibling;
    //   $(panel1.style.maxHeight);
    //   if (panel1.style.maxHeight) {
    //     panel1.style.maxHeight = null;
    //     $(this).find('span').removeClass("svgrotate_2");
    //   } else {
    //     panel1.style.maxHeight = panel1.scrollHeight + "px";
    //     $(this).find('span').addClass("svgrotate_2");
    //   }
    // });